import { viewportBreakpoints, viewportHeights } from './responsive';

const appTheme = Object.freeze({
  breakpoints: viewportBreakpoints,
  heights: viewportHeights
});

export default appTheme;

